import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createInventoryRelocation, editInventoryRelocation, fetchInventoryRelocationDetail } from '../../actions/inventoryRelocations_actions';
import { fetchInventories } from '../../actions/inventoryConverts_actions';

import InventoryRelocationFromInbound from '../../components/Inventories/inventoryRelocationFromInbound';

const validate = values => {
  const errors = {}
  if (!values.Quantity) {
      errors.Quantity = 'Required'
  }
  return errors
}

let inventoryRelocationFromInbound = reduxForm({
    form: 'inventoryRelocationFromInbound',
    validate
})(InventoryRelocationFromInbound);

const selector = formValueSelector('inventoryRelocationFromInbound')

function mapStateToProps(state) {
    const postingDate = selector(state, 'PostingDate');
    const note = selector(state, 'Note');
    return {
        postingDate,
        note,

        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
        currentInventoryRelocationDetail: state.inventoryRelocations.currentInventoryRelocationDetail,
        detailIsLoading: state.inventoryRelocations.detailIsLoading,
        detailError: state.inventoryRelocations.detailError,
        initialValues: state.inventoryRelocations.currentInventoryRelocationDetail,
        isCreating: state.inventoryRelocations.isCreating,
        createError: state.inventoryRelocations.createError,
        created: state.inventoryRelocations.created,
        isEditing: state.inventoryRelocations.isEditing,
        editError: state.inventoryRelocations.editError,
        edited: state.inventoryRelocations.edited,

        inventories: state.inventoryConverts.inventories,
        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,
        currentWarehouseReceive: state.putAway.currentWarehouseReceive
    }
}

export default connect(mapStateToProps, { createInventoryRelocation, editInventoryRelocation, fetchInventoryRelocationDetail, fetchInventories })(inventoryRelocationFromInbound)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx